import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";

import clubStore from "../../../../storage/ClubStore";

import MemberForm from "./MemberForm";


const NewMember = () => {

    useEffect(() => {
        clubStore.resetMember();

        clubStore.member.setProperty(
            "role_id",
            "MMBR"
        );
    }, []);


    useEffect(() => {
        if (
            !clubStore.club.id ||
            clubStore.member.company_id
        ) {
            return;
        }

        clubStore.member.setProperty(
            "company_id",
            clubStore.club.id
        );
    }, [clubStore.club.id]);


    return (
        <MemberForm />
    );
};


export default observer(NewMember);